import { render } from "./Accessoires.vue?vue&type=template&id=3c706cd4&scoped=true"
import script from "./Accessoires.vue?vue&type=script&lang=js"
export * from "./Accessoires.vue?vue&type=script&lang=js"

import "./Accessoires.vue?vue&type=style&index=0&id=3c706cd4&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c706cd4"]])

export default __exports__